











































































































































































































































































































































































































































































































































































































































































































































































































































































































import {
  Component,
  Model,
  Prop,
  Ref,
  Vue,
  Watch,
} from "vue-property-decorator";
import { Currency } from "@/shared/models/currency";
import {
  AccomodationUnitTypeViewModel,
  RoomViewModel,
  BedViewModel,
} from "@/shared/models/accomodationUnitTypeViewModel";
import MoreLessSelect from "@/components/misc/MoreLessSelect.vue";
import RatingInput from "@/components/misc/RatingInput.vue";
import WorkingCurrencyDisplay from "@/components/misc/WorkingCurrencyDisplay.vue";
import AccomodationUnitTable from "./AccomodationUnitTable.vue";
import AmenitiesSelection from "./AmenitiesSelection.vue";
import { Action, Getter } from "vuex-class";
import { RoomType } from "@/shared/models/roomType";
import { BedType } from "@/shared/models/bedType";
import PhotoEditor from "@/components/photo-editor/PhotoEditor.vue";
import FormDescription from "@/components/misc/FormDescription.vue";
import AccomodationUnitTypeDescriptions from "@/components/property/AccomodationUnitTypeDescriptions.vue";
import AccomodationUnitTypeOBCategoriesTable from "@/components/property/AccomodationUnitTypeOBCategoriesTable.vue";
import AccomodationUnitTypeTranslations from "@/components/property/AccomodationUnitTypeTranslations.vue";
import AddOnServicesTable from "./AddOnServicesTable.vue";
import OfficialRatesTable from "./official-rates/OfficialRatesTable.vue";
import AccomodationUnitTypeRatePlanOverrides from "./AccomodationUnitTypeRatePlanOverrides.vue";
import NumericInputImproved from "@/components/numbers/NumericInputImproved.vue";
import _ from "lodash";
import {
  CategoriesEnum,
  OfficialRatesExportType,
} from "@/shared/models/enums.type";
import { DateTime } from "luxon";
import AccomodationUnitTypeLOSCategoriesTable from "@/components/property/AccomodationUnitTypeLOSCategoriesTable.vue";
import { ListModel } from "@/shared/models/listModel";
import { ApiCredential } from "@/shared/models/apiCredential";
import { formatOrderbyArray } from "@/shared/sortHelperFunctions";
import { DataOptions } from "vuetify";
import OfficialRatesExportForOwners from "@/components/property/official-rates/OfficialRatesExportForOwners.vue";
import OfficialRatesExportForGuests from "./official-rates/OfficialRatesExportForGuests.vue";

@Component({
  components: {
    MoreLessSelect,
    RatingInput,
    AccomodationUnitTable,
    WorkingCurrencyDisplay,
    AmenitiesSelection,
    PhotoEditor,
    FormDescription,
    AccomodationUnitTypeDescriptions,
    AccomodationUnitTypeOBCategoriesTable,
    AccomodationUnitTypeTranslations,
    AddOnServicesTable,
    OfficialRatesTable,
    AccomodationUnitTypeRatePlanOverrides,
    NumericInputImproved,
    AccomodationUnitTypeLOSCategoriesTable,
    OfficialRatesExportForOwners,
    OfficialRatesExportForGuests,
  },
})
export default class AccomodationUnitTypeForm extends Vue {
  tab = "basicInfo";

  propertyId?: number;
  accUnitType: AccomodationUnitTypeViewModel =
    new AccomodationUnitTypeViewModel();
  original: AccomodationUnitTypeViewModel = new AccomodationUnitTypeViewModel();

  @Getter("appParams/typeId") tenantTypeId?: number;
  @Getter("appParams/workingCurrency") workingCurrency?: Currency;

  @Getter("appParams/tenantCanEditLOSCategories")
  tenantCanEditLOSCategories?: boolean;
  @Getter("appParams/tenantCanEditPAXCategories")
  tenantCanEditPAXCategories?: boolean;

  @Model() model!: AccomodationUnitTypeViewModel;

  @Watch("model", { immediate: true })
  modelChanged() {
    this.accUnitType = { ...this.model };
    this.original = _.cloneDeep(this.accUnitType);
  }
  @Watch("accUnitType", { deep: true })
  accUnitTypeChanged() {
    this.$emit("input", this.accUnitType);
  }

  @Watch("accUnitType.sortOrder")
  sortOrderWatch(fresh: number | string) {
    if (fresh === "") {
      this.accUnitType.sortOrder = null;
    }
  }

  @Watch("accUnitType.damageDeposit")
  depositChanged(fresh: number, old?: number) {
    if (fresh && !old) {
      this.accUnitType.depositCurrencyId = this.workingCurrency?.id;
    }
  }

  @Prop({ default: false }) isSubmitting?: boolean;

  loading = false;
  isBasicFormValid = false;
  isAmenitiesFormValid = false;
  isLayoutFormValid = false;
  isTranslationsFormValid = false;
  isDescriptionsFormValid = false;
  isPAXCategoriesFormValid = false;
  isPhotosFormValid = false;
  isUnitsFormValid = false;
  isLosCategoriesFormValid = false;
  exportOfficialRatesForOwnerOpen = false;
  exportOfficialRatesForGuestsOpen = false;
  officialRatesExportType = null;
  isLOSCategoriesFormValid = false;
  openApiKeySelection = false;
  selected: ApiCredential[] = [];
  headers = [
    {
      text: "Name",
      align: "start",
      sortable: false,
      value: "name",
    },
    { text: "Username", value: "userTenantUsername", sortable: false },
  ];

  officialRatesYear = DateTime.now().year;
  years = _.range(DateTime.now().year + 4, 2018, -1);

  officialRatesExportTypes = [
    {
      value: OfficialRatesExportType.InputPrice,
      text: "t.OfficialRateExport.InputPrice",
    },
    {
      value: OfficialRatesExportType.OutputPrice,
      text: "t.OfficialRateExport.OutputPrice",
    },
    {
      value: OfficialRatesExportType.InputAndOutputPrice,
      text: "t.OfficialRateExport.InputAndOutputPrice",
    },
  ];

  get submitDisabled(): boolean {
    return (
      !this.loading &&
      !this.isSubmitting &&
      this.isBasicFormValid &&
      this.isAmenitiesFormValid &&
      this.isLayoutFormValid &&
      this.isTranslationsFormValid &&
      this.isDescriptionsFormValid &&
      this.isPhotosFormValid &&
      this.isUnitsFormValid
    );
  }

  @Ref("formBasic") formBasic?: { validate: () => boolean };
  @Ref("formAmenities") formAmenities?: { validate: () => boolean };
  @Ref("formLayout") formLayout?: { validate: () => boolean };
  @Ref("formTranslations") formTranslations?: { validate: () => boolean };
  @Ref("formDescriptions") formDescriptions?: { validate: () => boolean };
  @Ref("formPhotos") formPhotos?: { validate: () => boolean };
  @Ref("formUnits") formUnits?: { validate: () => boolean };
  @Ref("formLOSCategories") formLOSCategories?: { validate: () => boolean };
  @Ref("formPAXCategories") formPAXCategories?: { validate: () => boolean };
  @Ref("ratePlans") ratePlansTab?: AccomodationUnitTypeRatePlanOverrides;

  refreshRatePlans() {
    if (this.ratePlansTab) {
      this.ratePlansTab.load();
    }
  }

  sanitizeNumberInputValuesOnModel() {
    // if the field is cleared after having a value, the value is "" instead of undefined
    // it's because how vue handles v-model.number because of some js particularity
    if (typeof this.accUnitType.squareSize != "number") {
      this.accUnitType.squareSize = undefined;
    }
    if (typeof this.accUnitType.maxNumberOfAdults != "number") {
      this.accUnitType.maxNumberOfAdults = undefined;
    }
    if (typeof this.accUnitType.basePrice != "number") {
      this.accUnitType.basePrice = undefined;
    }
    if (typeof this.accUnitType.damageDeposit != "number") {
      this.accUnitType.damageDeposit = undefined;
    }

    if (this.accUnitType.rooms) {
      for (const room of this.accUnitType.rooms) {
        if (typeof room.squareSize != "number") {
          room.squareSize = undefined;
        }
      }
    }
  }

  submit() {
    this.sanitizeNumberInputValuesOnModel();
    // validate
    const basicFormValid = this.formBasic?.validate();
    const basicAmenitiesValid = this.formAmenities?.validate();
    const basicLayoutValid = this.formLayout?.validate();
    const basicTranslationsValid = this.formTranslations?.validate();
    const basicDescriptionsValid = this.formPhotos?.validate();
    const basicPhotosValid = this.formPhotos?.validate();
    const basicUnitsValid = this.formUnits?.validate();
    const basicLOSCategoriesValid = this.formLOSCategories?.validate();
    const basicPAXCategoriesValid = this.formPAXCategories?.validate();

    if (
      !basicFormValid ||
      !basicAmenitiesValid ||
      !basicLayoutValid ||
      !basicTranslationsValid ||
      !basicDescriptionsValid ||
      !basicPhotosValid ||
      !basicUnitsValid ||
      (!basicLOSCategoriesValid && this.tenantCanEditLOSCategories) ||
      (!basicPAXCategoriesValid && this.tenantCanEditPAXCategories)
    ) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("Changes are invalid or incomplete"),
        timeout: 5000,
      });

      return;
    }

    //submit
    this.$emit("submit", this.accUnitType);
  }

  @Ref("translations") translationsRef?: { add: () => void };
  @Ref("descriptions") descriptionsRef?: { add: () => void };
  @Ref("losCategories") losCategoriesRef?: { add: () => void };
  @Ref("paxCategories") paxCategoriesRef?: { add: () => void };
  @Ref("photos") photosRef?: { add: () => void };
  @Ref("addOnServices") addOnServicesRef?: { add: () => void };
  @Ref("units") unitsRef?: {
    addUnit: (
      propertyAgencyWorkModel: number | null,
      propertyVATCategory: number | null,
      propertyOwnerPriceOffset: number | null,
      propertyAgencyCommissionPercentForPrepayments: number | null,
      propertyOwnerDoesCheckin: boolean | null,
      propertyOwnerDoesCheckout: boolean | null,
      propertyOwnerDoesCleaning: boolean | null,
      propertyCategorizationNumber: string | null,
      propertyCategorizationClass: string | null,
      propertyCategorizationDate: Date | null
    ) => void;
  };

  addBtn() {
    switch (this.tab) {
      case "units":
        this.unitsRef?.addUnit(
          this.model.propertyAgencyWorkModelId,
          this.model.propertyVATCategoryForPrepaymentsId,
          this.model.propertyOwnerPriceOffset,
          this.model.propertyAgencyCommissionPercentForPrepayments,
          this.model.propertyOwnerDoesCheckin,
          this.model.propertyOwnerDoesCheckout,
          this.model.propertyOwnerDoesCleaning,
          this.model.propertyCategorizationNumber,
          this.model.propertyCategorizationClass,
          this.model.propertyCategorizationDate
        );
        break;
      case "translations":
        this.translationsRef?.add();
        break;
      case "photos":
        this.photosRef?.add();
        break;
      case "LOSCategories":
        this.losCategoriesRef?.add();
        break;
      case "PAXCategories":
        this.paxCategoriesRef?.add();
        break;
    }
  }

  checkForChanges() {
    return _.isEqual(this.accUnitType, this.original);
  }

  resetFormModel() {
    this.original = _.cloneDeep(this.accUnitType);
  }

  back() {
    this.$router.back();
  }

  rules = {};

  async created() {
    this.rules = {
      required: (value: any) => !!value || this.$t("Validation.Required"),
      requiredAllowed0: (value: any) =>
        !!value || value === 0 || this.$t("Validation.Required"),
      name: (value: string) =>
        !value ||
        value.length <= 50 ||
        this.$t("Validation.MaxLength", { count: 50 }),
      wholeNumbersOnly: (value: number) =>
        value == null ||
        value == undefined ||
        value % 1 == 0 ||
        this.$t("Validation.MustBeWholeNumber"),
      noNegativeNumbers: (value: number) =>
        value == null ||
        value == undefined ||
        value >= 0 ||
        this.$t("Validation.MustBePositive"),
      maxValue: (value: number, max: number) =>
        value == null ||
        value == undefined ||
        value <= max  ||
        this.$t("Validation.MaxValue", { max: max }),
      inRange: (
        value: number | string, // vue... v-model.number when the field is empty returns and empty string...
        min: number,
        max: number,
        emptyAllowed: boolean
      ) =>
        ((value == null || value == undefined || value === "") &&
          emptyAllowed) ||
        (value >= min && value <= max) ||
        this.$t("Validation.MustBeInRange{min}{max}", { min: min, max: max }),
    };

    const promises = [];

    if ((this.bedTypes?.length ?? 0) === 0 && this.refreshBedTypes) {
      promises.push(this.refreshBedTypes());
    }
    if ((this.roomTypes?.length ?? 0) === 0 && this.refreshRoomTypes) {
      promises.push(this.refreshRoomTypes());
    }
    if ((this.currencies?.length ?? 0) === 0 && this.refreshCurrencies) {
      promises.push(this.refreshCurrencies());
    }

    await Promise.all(promises);
  }

  async mounted() {
    await this.load();
  }

  get showDepositCurrency() {
    return (
      !!this.accUnitType.damageDeposit || this.accUnitType.damageDeposit === 0
    );
  }

  @Action("codebooks/refreshBedTypes") refreshBedTypes?: () => Promise<void>;
  @Getter("codebooks/bedTypes") bedTypes?: BedType[];

  @Action("codebooks/refreshRoomTypes") refreshRoomTypes?: () => Promise<void>;
  @Getter("codebooks/roomTypes") roomTypes?: RoomType[];

  // prettier-ignore
  @Action("codebooks/refreshCurrencies") refreshCurrencies?: () => Promise<void>;
  @Getter("codebooks/currencies") currencies?: Currency[];

  @Getter("appParams/tenantUsesInputPrice") tenantUsesInputPrice?: boolean;
  @Getter("language/language") language?: string;
  @Getter("appParams/tenantUsesOfficialRates")
  tenantUsesOfficialRates?: boolean;

  get internalLanguage() {
    return this.language ?? "hr-HR";
  }

  get category() {
    if (this.accUnitType.categoryId === CategoriesEnum.Empty) {
      return 0;
    }
    return this.accUnitType.categoryId + 1;
  }
  set category(val: number) {
    if (
      val === 0 ||
      (val === 1 && this.accUnitType.categoryId === CategoriesEnum.Star2)
    ) {
      this.accUnitType.categoryId = CategoriesEnum.Empty;
    } else {
      this.accUnitType.categoryId = val - 1;
      if (val === 1) {
        this.$nextTick(() => {
          this.accUnitType.categoryId = CategoriesEnum.Star2;
        });
      }
    }
  }
  
  handleMouseClick() {
    if (this.accUnitType.maxNumberOfAdults === undefined) {
    this.accUnitType.maxNumberOfAdults = this.accUnitType.baseBedsCapacity + this.accUnitType.extraBedsCapacity;
    }
  }

  get sortedRoomTypes() {
    return (
      this.roomTypes?.map((x) => {
        return {
          value: x.id,
          name: this.$t(x.textResourceKey),
        };
      }) ?? []
    ).sort((a, b) => (a.name > b.name ? 1 : -1));
  }

  addRoom() {
    this.accUnitType.rooms.push(new RoomViewModel());
  }

  addBed(room: RoomViewModel) {
    room.beds.push(new BedViewModel());
  }

  async copyiCalendarLink() {
    if (typeof ClipboardItem && navigator.clipboard.write) {
      // Safari locks down the clipboard API to only work when triggered by a direct user interaction.
      // We can't use it async in a promise, but we can wrap the promise in a ClipboardItem, and give that to the clipboard API.
      // reference: https://developer.apple.com/forums/thread/691873
      navigator.clipboard.write([
        new ClipboardItem({
          "text/plain": this.fetchICalLink().then(
            (text) => new Blob([text], { type: "text/plain" })
          ),
        }),
      ]);
    } else {
      // Firefox has support for ClipboardItem and navigator.clipboard.write, but those are behind `dom.events.asyncClipboard.clipboardItem` preference.
      // On the other hand... Firefox can do this the "standard" way.
      navigator.clipboard.writeText(await this.fetchICalLink());
    }

    this.openApiKeySelection = false;
    this.selected = [];
    this.$store.dispatch("showNotification", {
      color: "success",
      message: this.$t("LinkCopiedToClipboard"),
      timeout: 5000,
    });
  }

  async fetchICalLink() {
    let result = "";

    await this.axios
      .get(
        "accomodationUnitTypes/GetICalLink?id=" +
          this.model.id +
          "&key=" +
          this.selected[0].id,
        {}
      )
      .then((res) => {
        result = res.data;
      });

    return result;
  }

  list: ListModel<ApiCredential> = {
    count: 0,
    result: [],
  };

  async load(): Promise<ListModel<ApiCredential>> {
    this.loading = true;

    return this.axios
      .get<ListModel<ApiCredential>>("/ApiCredentials", {
        params: this.queryParams,
      })
      .then((res) => {
        this.list.result = res.data.result.filter((x) =>
          x.name.includes("iCal")
        );
        this.list.count = this.list.result.length;

        return this.list;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  options: DataOptions = {
    page: 1,
    itemsPerPage: 15,
    sortBy: ["name"],
    sortDesc: [false],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: true,
  };

  get queryParams() {
    return {
      $skip: 0,
      $top: 100,
      $orderby: formatOrderbyArray(
        this.options.sortBy,
        this.options.sortDesc.map((x) => !x)
      ),
      $count: true,
    };
  }

  async checkApiKeys() {
    if (!this.list.count) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("ApiKey.iCal.AtLease1KeyRequired"),
        timeout: 10000,
      });
    } else if (this.list.count && this.list.count > 1) {
      this.openApiKeySelection = true;
    } else {
      this.selected[0] = this.list.result[0];
      this.copyiCalendarLink();
    }
  }
}
